export default __webpack_public_path__ + "static/media/MyEvent_AN.06e1a35a.svg";